export default "__VITE_ASSET__N_ySqroj__"